import type { BarcodeFixAction, BarcodeIssueRole } from '@/api/models';

/** The most items one fix takes, the catalog import's line cap. */
export const BARCODE_FIX_MAX_ITEMS = 2000;

/** One barcode to fix, named as the barcode issues list returned it. */
export type BarcodeIssueFixItem = {
    variantId: string;
    role: BarcodeIssueRole;
    /**
     * The code as the list showed it. When it is no longer the variant's main
     * barcode (`main`) or a live alternate (`alternate`), the whole call is
     * 409 `BARCODE_CHANGED`.
     */
    barcode: string;
    /** `generate` takes a main only, `remove` an alternate only. */
    action: BarcodeFixAction;
    /** For `type` only: 1–14 ASCII digits. No check digit is checked. */
    newBarcode?: string;
};

/**
 * Body for `POST /products/barcode-issues/fix` (bos-api API-207): every item
 * is applied or none is. At most `BARCODE_FIX_MAX_ITEMS` items; the refusals
 * are `BarcodeFixErrorCode`s.
 */
export type BarcodeIssuesFixRequest = {
    items: BarcodeIssueFixItem[];
    /**
     * The branch whose sellable stock each generated barcode's `units`
     * counts, under the list's scope rules; it changes nothing written. Sent
     * only when set.
     */
    branchId?: string | null;
};
